var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77459 3.43C7.70606 2.84123 8.81276 2.5 10 2.5C13.3137 2.5 16 5.15831 16 8.4375C16 12.5084 11.2 16.75 10 16.75C8.8 16.75 4 12.5084 4 8.4375C4 7.3938 4.27213 6.41299 4.75 5.56078",
    stroke: "#F8408C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1632 8.74612C12.2197 8.54884 12.25 8.34046 12.25 8.125C12.25 6.88236 11.2426 5.875 10 5.875C8.75736 5.875 7.75 6.88236 7.75 8.125C7.75 9.36764 8.75736 10.375 10 10.375C10.1726 10.375 10.3406 10.3556 10.502 10.3188",
    stroke: "#F8408C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.783be566c9637c9067e3403ee0022f85.svg";
export { ForwardRef as ReactComponent };